import React from 'react';
import { useCalendar } from '../context/CalendarContext';
import { format, getMonth, getYear, addMonths, startOfYear } from 'date-fns';
import MonthCard from './MonthCard'; // Importar o novo componente

const Calendar: React.FC = () => {
  const { currentYear, monthlyStats, updateMonthlyDemand } = useCalendar();

  const months = Array.from({ length: 12 }, (_, i) => {
    return startOfYear(new Date(currentYear, 0, 1));
  }).map((date, i) => addMonths(date, i));

  const firstHalfMonths = months.slice(0, 6);
  const secondHalfMonths = months.slice(6, 12);

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-4">
        {firstHalfMonths.map((monthDate) => {
          const monthKey = format(monthDate, 'yyyy-MM');
          const stats = monthlyStats[monthKey] || { demand: 0, capacity: 0, occupation: 0 };
          return (
            <MonthCard 
              key={`first-half-${monthKey}`}
              monthDate={monthDate}
              monthKey={monthKey}
              stats={stats}
              updateMonthlyDemand={updateMonthlyDemand}
            />
          );
        })}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
        {secondHalfMonths.map((monthDate) => {
          const monthKey = format(monthDate, 'yyyy-MM');
          const stats = monthlyStats[monthKey] || { demand: 0, capacity: 0, occupation: 0 };
          return (
            <MonthCard 
              key={`second-half-${monthKey}`}
              monthDate={monthDate}
              monthKey={monthKey}
              stats={stats}
              updateMonthlyDemand={updateMonthlyDemand}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Calendar;

